import _ from 'lodash'

/**
 * 配列処理ユーティリティークラス
 */
class ArrayUtil {
  /**
   * 2つの配列が順不同で同じ値を含む場合はtrue
   * @param {Array} a
   * @param {Array} b
   */
  isSame(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) {
      return a.length === b.length && _.intersection(a, b).length === a.length
    } else if (!Array.isArray(a) && !Array.isArray(b)) {
      return a === b
    } else {
      return false
    }
  }
}

export default new ArrayUtil()
